"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _Provider = _interopRequireDefault(require("./QueryContext/Provider"));
var _Provider2 = _interopRequireDefault(require("./RandomId/Provider"));
/**
 *
 * Use OrbitProvider with useId prop as follows to still use `react-uid`:
 * ```jsx
    <UIDReset>
      <UIDFork>
        <OrbitProvider theme={theme} useId={useUID}>
          {children}
        </OrbitProvider>
      </UIDFork>
    </UIDReset>
 * ```
 *
 */
const OrbitProvider = ({
  theme,
  children,
  useId
}) => {
  return /*#__PURE__*/React.createElement(_Provider2.default, {
    useId: useId
  }, /*#__PURE__*/React.createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(_Provider.default, null, children)));
};
var _default = OrbitProvider;
exports.default = _default;